// Labelled fields (DESIGN_SPEC §10.7): the label is visible ABOVE the control, never placeholder-as-label.
//   <Field label htmlFor? error? hint? messageId? className?>{control}</Field>
//       .field + mono CAPS .label; the error (ink, role=alert) or hint sits inline below — point the control's aria-describedby at messageId
//   <Input invalid? {...input attrs} />   .input (38px, rule-field border); invalid → aria-invalid ink edge
import type { ComponentProps, ReactNode } from "react";
import { cx } from "./cx";

export function Field({
  label,
  htmlFor,
  error,
  hint,
  messageId,
  className,
  children,
}: {
  label: ReactNode;
  htmlFor?: string;
  error?: ReactNode;
  hint?: ReactNode;
  messageId?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cx("field", className)}>
      {htmlFor ? (
        <label className="label" htmlFor={htmlFor}>
          {label}
        </label>
      ) : (
        <span className="label">{label}</span>
      )}
      {children}
      {error ? (
        <p id={messageId} className="meta text-ink" role="alert">
          {error}
        </p>
      ) : (
        hint && (
          <p id={messageId} className="meta">
            {hint}
          </p>
        )
      )}
    </div>
  );
}

export function Input({ invalid, className, ...rest }: ComponentProps<"input"> & { invalid?: boolean }) {
  return <input className={cx("input", className)} aria-invalid={invalid || undefined} spellCheck={false} {...rest} />;
}
